import httpRequest from '@/utils/request';

const LabelUrl = '/Label';
const generateUrlById = (id: string): string => {
  return `${LabelUrl}/${id}`;
};

export const getLabels = (
  params: ILabel.IRequest.IGetLabel = {},
): Promise<ILabel.IResponse.IData> => {
  return httpRequest.get(LabelUrl, {
    params,
  });
};
export const createLabel = (reqdata: ILabel.IRequest.IUpdateLabel): Promise<IResponseData.IBaseData> => {
  const data = {...reqdata.data, title: reqdata.data.name};
  return httpRequest.post(generateUrlById(reqdata.id), data);
};
export const updateLabel = (reqdata: ILabel.IRequest.IUpdateLabel): Promise<IResponseData.IBaseData> => {
  const data = {...reqdata.data, title: reqdata.data.name};
  return httpRequest.post(generateUrlById(reqdata.id), data);
};
export const delLabel = (id: string): Promise<IResponseData.IBaseData> => {
  return httpRequest.delete(generateUrlById(id));
};
